import React from 'react'
import { connect } from 'react-redux'
import SectionItem from '../../Layout/SectionItem/SectionItem'
import './Scheduling.scss'
import { LuxSelect } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import ProjectVisibility from './ProjectVisibility/ProjectVisibility'
import AutoClose from './AutoClose/AutoClose'
import SectionItemContainer from '../../Layout/SectionItemContainer/SectionItemContainer'
import ProjectDuration from './ProjectDuration/ProjectDuration'
import { FormBase, SchedulingForm } from '@/app/models/new-activity-form'

const priorityOptions = [
    { value: 'standard', label: 'modals.new.activity.section.scheduling.priority.standard' },
    { value: 'urgent', label: 'modals.new.activity.section.scheduling.priority.urgent' },
]

const Scheduling = (props: FormBase<SchedulingForm>) => {
    const { form, onSetForm, onSave, onClear, isDone } = props

    const intl = useIntl()

    const componentClass = 'smart-new-activity-scheduling'

    return (
        <div className={componentClass}>
            <SectionItemContainer
                hideFooter={true}
                onSave={() => onSave()}
                onClear={onClear}
                isDone={isDone}>
                <ProjectDuration form={form} onSetForm={(form) => onSetForm(form)} />
                <ProjectVisibility form={form} onSetForm={(form) => onSetForm(form)} />
                <SectionItem>
                    <div className={`${componentClass}__priority`}>
                        <LuxSelect
                            value={form.priority.value}
                            disabled={form.priority.disabled}
                            mandatory={true}
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, priority: { ...form.priority, value } })
                            }
                            label={intl.formatMessage({
                                id: 'modals.new.activity.section.scheduling.priority',
                                defaultMessage: 'Priority',
                            })}
                            options={priorityOptions.map((opt) => ({
                                ...opt,
                                label: intl.formatMessage({
                                    id: opt.label,
                                    defaultMessage: opt.label.split('.').pop(),
                                }),
                            }))}
                            placeholder={intl.formatMessage({
                                id: 'modals.new.activity.section.scheduling.priority.placeholder',
                                defaultMessage: 'Select priority',
                            })}
                            additionalProps={{
                                appendTo: 'self',
                            }}
                        />
                    </div>
                </SectionItem>
                <AutoClose form={form} onSetForm={(form) => onSetForm(form)} />
                {props.afterAutoClose}
            </SectionItemContainer>
        </div>
    )
}

export default Scheduling
